module.exports = __webpack_public_path__ + "img/20190726161758232.5ce2d640.png";